export const actions = {
    massDeletion: 'massDeletion',
    bulkUploadOfClassesOrMeetings: 'bulkUploadOfClassesOrMeetings',
    addLessonOrMeeting: 'addLessonOrMeeting',
    intersectionCheck: 'intersectionCheck',
    editLessonOrMeeting: 'editLessonOrMeeting',
    showLessonOrMeeting: 'showLessonOrMeeting',
    addingToPlanningTable: 'addingToPlanningTable',
    addGroups: 'addGroups',
    registerLesson: 'registerLesson',
    downloadImageWithCustomTitle: 'downloadImageWithCustomTitle'
}
